import _ from "lodash";
import { Modal, notification, Select } from "antd";
import React, { useEffect, useState } from "react";

import { InboxOutlined } from "@ant-design/icons";

import { Form, Input, Button, Radio, Upload, message } from "antd";
import { useGlobalStore } from "../../../../stores/globalBackendStore";
import parseMediaUrl from "../../functions/parseMediaUrl";
import {
  getGlobalMatchdays,
  uploadMedia,
} from "../../../../services/backend/api.service";
import { useTranslation } from "react-i18next";
import { Preview } from "./Preview";

const { Dragger } = Upload;

const validateMessages = {
  required: "'${name}' is required!",
  // ...
};

export default (props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const {
    id,
    visibleEdit,
    setVisibleEdit,
    editData,
    setEditData,
    setRefreshData,
    accept,
    feedType,
    onSlideItemChange,
    countries,
  } = props;

  const [confirmLoading, setConfirmLoading] = useState(false);
  const onValuesChange = (value) => {
    const { uuid } = editData;
    onSlideItemChange({
      uuid: uuid,
      changed: value,
    });
  };

  const onFinish = async (values) => {
    setConfirmLoading(false);
    setVisibleEdit(false);
    setRefreshData(true);
  };

  const onSave = (data) => {
    setConfirmLoading(true);
    form.submit();
  };

  useEffect(() => {
    if (editData && editData.url) {
      form.setFieldsValue({
        label: editData.label,
      });
    }
  }, [editData]);

  const slideFields = [
    {
      label: "Box Position",
      name: "box",
      type: "select",
      selectData: [
        {
          label: "No box",
          value: "no",
        },
        {
          label: "Left",
          value: "left",
        },
        {
          label: "Right",
          value: "right",
        },
      ],
      value: "no",
    },
    {
      label: "Country",
      name: "country",
      type: "select",
      selectData: countries.map((item) => {
        return { value: item.id, label: item.name };
      }),
      value: "",
    },
    {
      label: "Discipline",
      name: "discipline",
      type: "text",
      value: "",
    },
    {
      label: "Title",
      name: "boxTitle",
      type: "text",
      value: "",
    },
    {
      label: "Desc",
      name: "boxDesc",
      type: "text",
      value: "",
    },
  ];
  //use label, when data is empty
  const getInitialValues = () => {
    const values = slideFields.map((field) => {
      return {
        [field.name]: field.value,
      };
    });
    const valuesObj = {};
    for (const value of values) {
      const keys = Object.keys(value);
      const key = keys[0];
      if (editData[key]) {
        valuesObj[key] = editData[key];
      } else {
        valuesObj[key] = value[key];
      }
    }
    return valuesObj;
  };

  return (
    <Modal
      title="Slide edit"
      style={{ top: 20 }}
      open={visibleEdit}
      okText={"Save"}
      confirmLoading={confirmLoading}
      onOk={() => {
        onSave();
      }}
      onCancel={() => {
        setEditData({
          content_type: "image",
          group: "_default",
          uuid: "0",
        });
        setVisibleEdit(false);
      }}
      maskClosable={false}
      width={1000}
      height={700}
      className={"slide-edit-form"}
    >
      <Preview item={editData} feedType={feedType} countries={countries} />
      <Form
        validateMessages={validateMessages}
        layout={"horizontal"}
        form={form}
        initialValues={getInitialValues()}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
      >
        <Form.Item hidden={true} key={"files"} name={"files"} rules={[]}>
          <Input />
        </Form.Item>

        {_.map(slideFields, (item, key) => {
          const itemType = item.type;
          return (
            <Form.Item
              key={item.name}
              label={item.label}
              name={item.name}
              rules={[]}
            >
              {itemType === "input" && <Input placeholder={item.label} />}
              {itemType === "text" && <Input placeholder={item.label} />}
              {itemType === "select" && (
                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder={item.label}
                  optionFilterProp="children"
                  allowClear={true}
                  onClear={() => {}}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {_.map(item.selectData, (_item, itemIndex) => {
                    const key = _item.value;
                    const label = _item.label;
                    return (
                      <Option key={"s" + key} value={key}>
                        {label}
                      </Option>
                    );
                  })}
                </Select>
              )}
            </Form.Item>
          );
        })}
      </Form>
    </Modal>
  );
};
